// @ts-nocheck
// Site-wide utilities (header nav, footer). Loaded on every template.
// Accessiblility Js
document.querySelectorAll(".nav__menuItem").forEach((item) => {
    const link = item.querySelector(".nav__link");
  
    item.addEventListener("mouseenter", () => {
      link.setAttribute("aria-expanded", "true");
    });
  
    item.addEventListener("mouseleave", () => {
      link.setAttribute("aria-expanded", "false");
    });
  });
  
  document.addEventListener("DOMContentLoaded", function () {
    var el = document.getElementById("shopify-section-footer");
    if (el) el.setAttribute("role", "contentinfo");
  });

/**
 * Truncate Toggle Functionality
 * Direct JavaScript conversion from TypeScript toggle-truncate.directive.ts
 * Handles show more/less functionality for truncated text
 *
 * USAGE:
 * <div truncate>
 *   <div truncate-text class="truncated">Long text...</div>
 *   <button truncate-btn>Show More</button>
 * </div>
 */
(function initTruncate() {
  /**
   * @param {ParentNode} [root=document]
   */
  function bindTruncateContainers(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const truncateContainers =
      root && root.nodeType === 1 && root.matches('[truncate]')
        ? [root]
        : scope.querySelectorAll('[truncate]');

    truncateContainers.forEach((container) => {
      if (!(container instanceof HTMLElement) || container.dataset.abchomeTruncateInit === '1') {
        return;
      }

      const truncateText = container.querySelector('[truncate-text]');
      const truncateBtn = container.querySelector('[truncate-btn]');

      if (!truncateText || !truncateBtn) {
        return;
      }

      container.dataset.abchomeTruncateInit = '1';

      // Get translation text from button's initial content or data attributes
      // Preserve the original button text (which should have translation applied via Liquid)
      const originalButtonText = truncateBtn.textContent.trim() || truncateBtn.innerHTML.trim();
      const showMoreText = truncateBtn.dataset.showMore || originalButtonText || 'Show More';
      const showLessText =
        truncateBtn.dataset.showLess ||
        originalButtonText.replace(/more/i, 'less').replace(/Show/i, 'Show') ||
        'Show Less';

      // Initialize - check if text needs truncation
      const init = () => {
        if (
          truncateText.offsetHeight < truncateText.scrollHeight ||
          truncateText.offsetWidth < truncateText.scrollWidth
        ) {
          // Text is truncated, show button
          truncateBtn.style.display = 'inline-block';
          truncateBtn.style.pointerEvents = 'all';
        } else {
          // Text fits, hide button
          truncateBtn.style.display = 'none';
          truncateBtn.style.pointerEvents = 'none';
          truncateText.classList.remove('truncated');
        }
      };

      // Click handler
      truncateBtn.addEventListener('click', () => {
        const isTruncated = truncateText.classList.contains('truncated');

        if (isTruncated) {
          // Expand - remove truncated class
          truncateText.classList.remove('truncated');
          truncateBtn.innerHTML = showLessText;
        } else {
          // Contract - add truncated class
          truncateText.classList.add('truncated');
          truncateBtn.innerHTML = showMoreText;
        }
      });

      // Resize handler with debounce
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (!truncateText.classList.contains('truncated')) {
            truncateText.classList.add('truncated');
          }
          init();
        }, 150);
      });

      // Initial check
      init();
    });
  }

  window.ABCHOME_initTruncateIn = bindTruncateContainers;
  bindTruncateContainers(document);
})();
